import React from "react";
import type { WovarTeamSlice } from "~/lib/prismic";
import type { SliceComponentProps } from "@commercekit/prismic";
import { PrismicImage } from "@prismicio/react";
import { asText } from "@prismicio/helpers";
import type { ImageFieldImage } from "@commercekit/prismic";

const WovarTeam = ({ slice, context }: SliceComponentProps<WovarTeamSlice>) => {
  return (
    <div className="row">
      <article className="col content mb-3 mb-lg-5">
        <div className="py-3">
          <div className="row team">
            {slice?.items?.map((member, index) => (
              <div
                key={asText(member.employee_name) + index}
                className="col-6 col-sm-4 col-lg-4 col-xl-3 text-center mb-5 px-sm-4 px-lg-5"
              >
                <div className="team__image">
                  <div className="team__image-clipping">
                    {member?.employee_image?.url ? (
                      <PrismicImage
                        field={member?.employee_image}
                        loading="lazy"
                      />
                    ) : (
                      <PrismicImage
                        field={context as ImageFieldImage}
                        loading="lazy"
                      />
                    )}
                  </div>
                </div>

                <p className="team__quote heading handwritten lg mb-3">
                  {asText(member?.employee_quote)}
                </p>

                <h3 className="team__name heading strong md mb-0">
                  {asText(member?.employee_name)}
                </h3>

                <p className="team__function heading sans-serif md">
                  {asText(member?.employee_role)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </article>
    </div>
  );
};

export default WovarTeam;
